import styled from 'styled-components';

const PopupClose = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
`;

export default PopupClose;
